import type { Classroom } from '@innovamat/glow-api-client';
import type { QueryClient } from '@tanstack/react-query';

type ClassroomsQueryData = { classrooms: Classroom[] };

function leaveClassroomFromCache({
  queryClient,
  orgId,
  classroomId,
}: {
  queryClient: QueryClient;
  orgId: string;
  classroomId: string;
}): void {
  const variablesMine = ['Classrooms', { mine: true, orgId }];

  const currentClassroomsMine =
    queryClient.getQueryData<ClassroomsQueryData>(variablesMine)?.classrooms;

  if (currentClassroomsMine) {
    queryClient.setQueryData(variablesMine, {
      classrooms: currentClassroomsMine.filter(
        (classroom) => classroom.id !== classroomId
      ),
    });
  }
}

export { leaveClassroomFromCache };
